/**
 * @module compareResults
 */
import { createReducer } from '@reduxjs/toolkit';
import { surveyReportingActions } from '~/behaviors/actions/survey_reporting.actions';
import { reportingActions } from '~/behaviors/actions/reporting.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';
import { accountActions } from '~/behaviors/actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeCompareResults = (state, action) => {
  const compareResults = action.payload?.entities?.compareResults || {};

  return {
    ...state,
    ...compareResults,
  };
};

const replaceCompareResults = (state, action) => {
  const compareResults = action.payload?.entities?.compareResults || {};
  return compareResults;
};

const replaceBenchmarkCompareResults = (state, action) => {
  return action.payload?.benchmarkCompareResults || {};
};

const compareResults = createReducer(defaultState, (builder) => {
  builder
    .addCase(metaActions.reset, reset)
    .addCase(accountActions.logout.pending, reset)
    .addCase(accountActions.switchCompany.pending, reset)
    .addCase(surveyReportingActions.fetchReportingCompareResults.fulfilled, replaceCompareResults)
    .addCase(surveyReportingActions.fetchReportingAttributeCompareResults.fulfilled, mergeCompareResults)
    .addCase(reportingActions.resetCompared, reset)
    .addCase(reportingActions.removeReportingAttributeValues, reset)
    .addCase(reportingActions.setReportingSurveys, reset)
    .addCase(surveyReportingActions.updateBenchmarkCompareResults, replaceBenchmarkCompareResults);
});

export default compareResults;
